import { useTruncation, TitleOnTruncate } from "@cdkglobal/radial";

interface TruncatedCellRendererProps {
  children: React.ReactNode;
}

export default function TruncatedCellRenderer({
  children,
}: Readonly<TruncatedCellRendererProps>): JSX.Element {
  useTruncation();

  return <TitleOnTruncate>{children}</TitleOnTruncate>;
}
